import { ChangeEvent, ChangeEventHandler, MouseEvent, useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Chat, { ChatProps } from '../../components/app/chat/Chat';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'; //direkte Unterstützung für Fußnoten, Durchstreichungen, Tabellen, Aufgabenlisten und URLs
import rehypeKatex from 'rehype-katex'; //um Mathematik darzustellen
import remarkMath from 'remark-math'; //Mathematik in Markdown zu unterstützen
import rehypeRaw from 'rehype-raw'; // HTML in markdown
import rehypeStringify from 'rehype-stringify';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import rehypeFormat from 'rehype-format';
import remarkEmoji from 'remark-emoji'; //display short cut emojis
import {faArrowLeftLong, faChevronRight,faCopy,faHeadphones,faPlay} from '@fortawesome/free-solid-svg-icons'
import sengiCoin from "../../assets/sengi_coin.png";
import { extensionsRichTextEditor, MenuBarRichTextEditor } from '../../components/app/wordEditor/MenuBarTextEditor';
import { EditorContent, useEditor } from '@tiptap/react';
import { exampleUserChat, userChatsExample } from '../../components/app/chat/ChatExampleData';
import { ChatMessage } from '../../types/backend/SengiLabsTypes';
import { Link } from 'react-router-dom';

//TODO:send first hidden message with job definition in backend and get chatID 
export default function PromptChecker() {
    const { t } = useTranslation('toolsApps');

    const [prompt, setPrompt] = useState('');
    const [acceptAGB, setAcceptAGB] = useState(false);
    const [acceptCosts, setAcceptCosts] = useState(false);
    const [analysisStart, setAnalysisStart] = useState(false);

    const editor = useEditor({
        extensions: extensionsRichTextEditor,
        content: prompt,
        onUpdate({ editor }) {
        setPrompt(editor.getHTML());
        },
    });

    const hancleCheckBoxAGB = (event:ChangeEvent<HTMLInputElement>) => {
        const value = event.target.checked;
        setAcceptAGB(value);
    };
    const hancleCheckBoxCosts = (event:ChangeEvent<HTMLInputElement>) => {
        const value = event.target.checked;
        setAcceptCosts(value);
    };

    const getChatMessages = (messages:ChatMessage[]) => {
        if(messages.length > 0 && messages[messages.length-1].role == 'assistant' && messages[messages.length-1].contents.length === 1){
            let lastMessage = messages[messages.length-1].contents[0].element;
            setPrompt(lastMessage);
            editor.commands.setContent(lastMessage);
        }
    };
    //USE EFFECTS
    useEffect(() => {
        document.title = t('promptChecker.documentTitle');
        let navbarTitle = document.getElementById('navbar_title');
        if(navbarTitle){
            navbarTitle.textContent = t('promptChecker.documentTitle');
        }
      },[]);

    if (!editor) {
        return (<></>);
    }
    return (
        <div className="container-fluid">
            <div className='d-flex flex-column h-100'>
                <div className='row mx-0'>
                    <div className='col-auto py-2 px-0'>
                        <Link 
                            to="/executions" 
                            className="btn btn-outline-secondary btn-sm ms-3"
                        >
                        <FontAwesomeIcon
                                icon={faArrowLeftLong}
                                size="1x"
                                title={t('back')}
                            />
                        </Link>
                    </div>
                </div>
                <div className='row'>
                    <div className='h1  text-light p-2'> {t('promptChecker.heading')}</div>
                </div>
                { !analysisStart
                    ?   <>
                            <div className='row text-light'>
                                <p>{t('promptChecker.intro')}</p>
                            </div>
                            <div className='row text-light my-2'>
                                <div className="col-10 ms-5">
                                    <div className='form-check'>
                                        <input
                                        className="form-check-input border-light"
                                        type='checkbox'
                                        name='acceptAGBs'
                                        id='acceptAGBs'
                                        checked={acceptAGB}
                                        onChange={event => hancleCheckBoxAGB(event)}
                                        />
                                        <label htmlFor='acceptAGBs' className='form-check-label'>
                                        {t('promptChecker.acceptTerms')}
                                        </label>
                                    </div>
                                    <div className='form-check'>
                                        <input
                                        className="form-check-input border-light"
                                        type='checkbox'
                                        name='acceptCosts'
                                        id='acceptCosts'
                                        checked={acceptCosts}
                                        onChange={event => hancleCheckBoxCosts(event)}
                                        />
                                        <label htmlFor='acceptCosts' className='form-check-label'>
                                            {t('promptChecker.acceptCostsLabel')}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className={`row center mt-5 ${analysisStart? 'border-bottom pb-5' : ''}`}>
                                <div className='col'></div>
                                <div className='col'>
                                    <button
                                        className='btn btn-primary'
                                        title={t('promptChecker.startAnalysisTitle')}
                                        disabled={!acceptAGB || !acceptCosts}
                                        onClick={() => setAnalysisStart(true)}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPlay}
                                            className='me-2 ms-0'
                                            size={'1x'}
                                        />
                                        {t('promptChecker.startAnalysisButton')}
                                    </button>
                                </div>
                                <div className='col'></div>
                            </div>
                        </>
                    :   <>
                            <div className='row flex-grow-1 overflow-hidden'>
                                <div className='col-6 border-end scroll-y'>
                                    <MenuBarRichTextEditor editorIN={editor} />
                                    <EditorContent
                                        className='flex-grow-1 p-3 overflow-auto'
                                        editor={editor}
                                    />
                                </div>
                                <div className='col-6'>
                                    <Chat
                                        chatID=''
                                        getChatMessages={getChatMessages}
                                    />
                                </div>
                            </div>
                        </>
                }
            </div>
        </div>
    );
}
